import { useEffect } from "react";

export const useKeyPress = (keys, action) => {
  useEffect(() => {
    function onKeyup(e) {
      const tag = e.target.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;
      if (keys.includes(e.key)) {
        action();
      }
    }
    window.addEventListener("keyup", onKeyup);
    return () => window.removeEventListener("keyup", onKeyup);
  }, [action, keys]);
};
